// Traductions du mode Lite : page « journal ».
export const fr = {
  select: "Sélectionner",
  selectDone: "Terminer",
  selectedCount: (n: number) => `${n} trade${n > 1 ? "s" : ""} sélectionné${n > 1 ? "s" : ""}`,
  clearSelection: "Tout désélectionner",
  title: "Journal",
  subtitle: "Tes trades, jour par jour. Clique sur un trade pour l'annoter.",
  addTrade: "Ajouter un trade",
  import: "Importer",
  export: "Exporter",
  exportHint: "Exporter les trades affichés en CSV",
  searchPlaceholder: "Symbole, tag ou mot dans une note",
  searchLabel: "Rechercher dans le journal",
  clearDay: "Retirer le filtre du jour",
  outcome: { all: "Tous", win: "Gagnants", loss: "Perdants" },
  winners: (pct: string) => `${pct} gagnants`,
  emptyTitle: "Ton journal est vide",
  emptyText: "Chaque trade apparaîtra ici, regroupé par journée avec son total. Tu pourras l'annoter : note, tags, ressenti.",
};

export const en: typeof fr = {
  select: "Select",
  selectDone: "Done",
  selectedCount: (n: number) => `${n} trade${n > 1 ? "s" : ""} selected`,
  clearSelection: "Clear selection",
  title: "Journal",
  subtitle: "Your trades, day by day. Click a trade to annotate it.",
  addTrade: "Add a trade",
  import: "Import",
  export: "Export",
  exportHint: "Export the displayed trades as CSV",
  searchPlaceholder: "Symbol, tag or word in a note",
  searchLabel: "Search the journal",
  clearDay: "Remove the day filter",
  outcome: { all: "All", win: "Winners", loss: "Losers" },
  winners: (pct: string) => `${pct} winners`,
  emptyTitle: "Your journal is empty",
  emptyText: "Every trade will show up here, grouped by day with its total. You can annotate it: note, tags, feelings.",
};
